<template lang="pug">
    div
        template(v-for="refinementGroup in refinementGroups")
            SearchRefinementList(
                :title="refinementGroup.title"
                :values="refinementGroup.values"
                :isLight="isLight"
                :isCollapsedDefault="isCollapsedDefault"
            )
                template(#default="{ display, route }")
                    nuxt-link(:to="route" class="text-dark") {{ display }}
</template>

<script>
import SearchComponent from '@/components/search/component'
import SearchRefinementList from '@/components/search/refinementList'
import { linkBuilders } from '@/helpers/mixins'

export default {
    components: {
        SearchRefinementList,
    },
    extends: SearchComponent,
    mixins: [linkBuilders],
    props: {
        level: {
            type: Number,
            required: true,
        },
        isLight: {
            type: Boolean,
            default: false,
        },
        isCollapsedDefault: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        catalogData() {
            return this.$store.state.catalog.data
        },
        refinementGroups() {
            const refinementNames =
                this.$searchContext.state.refinements[`categories.lvl${this.level}.text`] || []
            const refinementSlugs =
                this.$searchContext.state.refinements[`categories.lvl${this.level}.slug`] || []

            const isCategoryPage = this.$route.name.includes('category')
            const isBrandPage = this.$route.name.includes('brand')

            const isInStockSameDayActive = this.$searchContext.isRefined('sameDayShipping')

            const refinements = refinementNames.map((refinement, index) => {
                const slug = refinementSlugs[index].value.split('|')

                const routeObj = {
                    name: 'category',
                    params: slug.reduce((acc, lvl, lvlIndex) => {
                        acc[`lvl${lvlIndex}`] = lvl
                        return acc
                    }, {}),
                    query: {},
                }

                // On Brand pages make sure we add the brand query filter to the route obj
                if (isBrandPage) routeObj.query.brand = this.$store.state.catalog.data.title

                // If ISSD is active make sure we add the sameDayShipping query filter to the route obj
                if (isInStockSameDayActive)
                    routeObj.query.sameDayShipping = this.$route.query.sameDayShipping

                return {
                    ...refinement,
                    slug,
                    route: this.linkBuilder(routeObj),
                }
            })

            if (this.$route.name !== 'mmy' || !this.$sitewideData.config.useSecondLevel) {
                // If we are on a category page we need to make sure we only show child categories of the current parent
                // Ex: If a product is in 2 root categories it would display both children in the list and thats not ideal.
                const values = isCategoryPage
                    ? refinements.filter(
                          (refinement) =>
                              refinement.slug.join('/').indexOf(this.catalogData.slug) === 0
                      )
                    : refinements

                return [
                    {
                        title: 'Category',
                        values,
                    },
                ]
            }

            const rootCategories = refinements.reduce((acc, refinement) => {
                const [group] = refinement.slug
                const [title] = refinement.value.split('|')

                if (!acc[group]) acc[group] = { title: '', values: [] }

                acc[group].title = title
                acc[group].values.push(refinement)

                return acc
            }, {})

            return Object.keys(rootCategories)
                .sort()
                .map((key) => {
                    return rootCategories[key]
                })
        },
    },
}
</script>
